module.exports = __webpack_public_path__ + "img/bb_g1_t_eyes-01.cf33cc9f.svg";